export const PAGE_PERMISSIONS = [
  { key: "dashboard", label: "Panel", path: "/adminxx1/dashboard" },
  { key: "students", label: "Öğrenciler", path: "/adminxx1/students" },
  { key: "parents", label: "Veliler", path: "/adminxx1/parents" },
  { key: "teachers", label: "Öğretmenler", path: "/adminxx1/teachers" },
  { key: "bep", label: "BEP Modülü", path: "/adminxx1/bep" },
  { key: "notes", label: "Günlük Notlar", path: "/adminxx1/notes" },
  { key: "tasks", label: "Aile Ev Ödevi", path: "/adminxx1/tasks" },
  { key: "activity_pool", label: "Etkinlik Havuzu", path: "/adminxx1/activity-pool" },
  { key: "feedback", label: "Geri Bildirimler", path: "/adminxx1/feedback" },
  { key: "pools", label: "Gelişimsel Profil", path: "/adminxx1/pools" },
  { key: "ai_reports", label: "AI Gelişim Raporu", path: "/adminxx1/ai-reports" },
  { key: "settings", label: "Site Ayarları", path: "/adminxx1/settings" },
  { key: "pages", label: "Sayfalar", path: "/adminxx1/pages" },
  { key: "roles", label: "Rol Yetkileri", path: "/adminxx1/roles" },
  { key: "packages", label: "Paketler", path: "/adminxx1/packages" },
];

export const ROLE_LABELS = {
  institution_admin: "Kurum Yöneticisi",
  teacher: "Öğretmen",
};

export function hasPermission(user, key) {
  if (!user) return false;
  if (user.role === "super_admin") return true;
  return (user.permissions || []).includes(key);
}

export function firstAllowedPath(user) {
  if (user?.role === "super_admin") return "/adminxx1/dashboard";
  const perm = PAGE_PERMISSIONS.find((p) => hasPermission(user, p.key));
  return perm?.path || "/adminxx1/dashboard";
}

export function permissionForPath(pathname) {
  const match = PAGE_PERMISSIONS.find(
    (p) => pathname === p.path || pathname.startsWith(`${p.path}/`),
  );
  return match?.key;
}

export function hasPackagePermission(user, key) {
  if (!user) return false;
  if (user.role === "super_admin") return true;
  if (!user.subscription_enabled) return true;
  if (user.role !== "teacher") return true;
  return (user.package_permissions || []).includes(key);
}

export function needsPackageGate(user, permissionKey) {
  if (!user || !permissionKey) return false;
  if (!user.subscription_enabled) return false;
  if (user.role !== "teacher") return false;
  if (!hasPermission(user, permissionKey)) return false;
  return !hasPackagePermission(user, permissionKey);
}
